import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import CheckIcon from "../../shared/Icons/CheckIcon";
import { useOnboardingContext } from "../OnboardingApp";
import { taskState, isInternalTask } from "../checklistFilters";

const STATUS_LABELS = { done: "Complete", overdue: "Overdue", open: "Not started" };

const TaskRow = ({ task }) => {
  const { checklist, toggleTask, pendingTaskIds } = useOnboardingContext();
  const state = taskState(task);
  const internal = isInternalTask(task);
  const pending = pendingTaskIds.includes(task.id);
  const togglable = !task.locked && !pending;
  const ownerLabel = internal ? "Opendate" : checklist.account.name || "Your team";

  return (
    <div className={`onboarding-task-row ${state === "overdue" ? "onboarding-task-row-overdue" : ""}`}>
      <button
        type="button"
        className={`onboarding-task-checkbox onboarding-task-checkbox-${state}`}
        onClick={() => togglable && toggleTask(task)}
        disabled={!togglable}
        aria-label={state === "done" ? `Mark ${task.title} not done` : `Mark ${task.title} done`}
      >
        {state === "done" && <CheckIcon fill="currentColor" />}
      </button>

      <div className="onboarding-task-main">
        <span className={`onboarding-task-title ${state === "done" ? "onboarding-task-title-done" : ""}`}>
          {task.title}
        </span>
        {task.completed_via === "auto" && <span className="onboarding-task-auto">Auto</span>}
        {task.description && <span className="onboarding-task-desc">{task.description}</span>}
      </div>

      <span className="onboarding-task-role">{ownerLabel}</span>

      <span className={`onboarding-task-due ${state === "overdue" ? "onboarding-task-due-overdue" : ""}`}>
        {task.due_date ? moment(task.due_date).format("MMM D") : "—"}
      </span>

      <span className={`onboarding-task-pill onboarding-task-pill-${state}`}>
        {pending ? "Saving…" : STATUS_LABELS[state]}
      </span>
    </div>
  );
};

TaskRow.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    owner_role: PropTypes.string,
    status: PropTypes.string,
    due_date: PropTypes.string,
    completed_via: PropTypes.string,
    internal: PropTypes.bool,
    locked: PropTypes.bool,
  }).isRequired,
};

export default TaskRow;
